var HEADER_BRAND_APPEARANCES = ['square', 'tall'];

export { HEADER_BRAND_APPEARANCES };
